import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import QuantityButton from "../../QuantitiyButton";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import i18n from "../../../../i18nextInitiator";
import {
  addExpensive,
  removeExpensive,
} from "../../../../actions/actionCreators";
import { connect } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";

/**
 * styles.
 * @type {(props?: any) => ClassNameMap<"root"|"card">}
 */
const useStyles = makeStyles((theme) => ({
  item: {
    padding: "0 .5rem",
    justifyContent: "space-between",
  },
  paper: {
    border: `solid 1px rgba(0, 0, 0, 0.13)`,
    borderRadius: ".3rem",
    boxShadow: "unset",
    margin: ".5rem 0",
  },
}));
const t = i18n.getFixedT("fa", "general");
const mapStateToProps = (state) => ({ ...state.order });

/**
 * The bottom card sticky card.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const HeavyItemCard = (props) => {
  const classes = useStyles();
  const { order: { vasayeleHazinedar: heavyItems } = {} } = props;

  const Skeletons = () => {
    return Array(8)
      .fill(1)
      .map((item, index) => (
        <Paper key={index} classes={{ elevation1: classes.paper }}>
          <Grid container className={classes.item}>
            <Grid
              item
              xs={6}
              style={{ margin: "auto 0" }}
              onClick={() => addExpensive(item)}
            >
              <Typography
                component={"span"}
                color={"primary"}
                style={{ fontWeight: "bold" }}
              >
                <Skeleton />
              </Typography>
            </Grid>
            <Grid item xs={"auto"}>
              <QuantityButton value={0} />
            </Grid>
          </Grid>
        </Paper>
      ));
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography>{t("heavy-description")}</Typography>
      </Grid>

      <Grid item xs={12} bottom>
        {heavyItems.length > 0 ? (
          heavyItems.sort((a, b) =>
            a.view_priority > b.view_priority ? 1 : -1
          ) &&
          heavyItems.map((item, index) => {
            const itemFromArray =
              props.order &&
              props.order.vasayeleHazinedar.find((i) => i.id === item.id);
            const count = itemFromArray.count ?? 0;
            return (
              <Paper key={index} classes={{ elevation1: classes.paper }}>
                <Grid container className={classes.item}>
                  <Grid
                    item
                    xs={6}
                    style={{ margin: "auto 0" }}
                    onClick={() => addExpensive(item.id)}
                  >
                    <Typography
                      component={"span"}
                      color={"primary"}
                      style={{ fontWeight: "bold" }}
                    >
                      {item.title}
                    </Typography>
                    <Typography component={"span"} variant={"caption"}>
                      &nbsp;{item.description}
                    </Typography>
                  </Grid>
                  <Grid item xs={"auto"}>
                    <QuantityButton
                      value={count}
                      add={() => addExpensive(item.id)}
                      remove={() => removeExpensive(item.id)}
                    />
                  </Grid>
                </Grid>
              </Paper>
            );
          })
        ) : (
          <Skeletons />
        )}
      </Grid>

      <Button
        onClick={props.close}
        size={"large"}
        variant="contained"
        color={"primary"}
        fullWidth
      >
        {t("submit")} {t("heavy-items")}
      </Button>
    </>
  );
};
export default connect(mapStateToProps)(HeavyItemCard);
